import { useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import TitleWithCount from '../../components/PageHelpers/TitleWithCount.jsx'
import SearchBar from '../../components/PageHelpers/SearchBar.jsx'
import SortByList from '../../components/PageHelpers/Sort.jsx'
import SummariesBtn from '../../components/PageHelpers/SummariesBtn.jsx'
import LoadMoreBtn from '../../components/PageHelpers/LoadMoreBtn.jsx'
import {
  retrieveCompanies,
  companyPagination,
  filterCompanies,
  searchCompanies,
  sortCompanies,
  addCompany,
} from '../../redux/features/companies/companiesThunk'
import { selectCompanies } from '../../redux/features/companies/companiesSlice'
import CompanyCard from '../../components/Cards/CompanyCard.jsx'
import CompanyModal from '../../components/Modals/CompanyModal.jsx'
import Loader from '../../components/helpers/Loader.jsx'

const Index = () => {
  const dispatch = useDispatch()
  const companies = useSelector(selectCompanies)

  useEffect(() => {
    dispatch(retrieveCompanies())
  }, [dispatch])

  return (
    <Box sx={styles.container}>
      <Loader store={companies} />
      <Box sx={styles.titleBox}>
        <Typography sx={styles.welcomeHeader}>Welcome User</Typography>
        <SearchBar
          actionToDispatch={searchCompanies}
          searchPlaceholder='Search by Company or Tenant'
          customStyles={styles.searchBarContainer}
        />
      </Box>
      <Box sx={styles.body}>
        <Box sx={styles.optionsBox}>
          <SummariesBtn actionToDispatch={filterCompanies} store={companies} />
          <Box sx={styles.sortAddBox}>
            <SortByList actionToDispatch={sortCompanies} store={companies} />
            <CompanyModal
              actionToDispatch={addCompany}
              modalTitle='Add New Company'
              modalMessage='This company has been added successfully'
              data={{ tenant: companies.lastTenant }}
            />
          </Box>
        </Box>

        <TitleWithCount pageName='All Companies' store={companies} customStyles={styles.titleContainer} />
        {companies?.value?.length > 0 &&
          companies?.value?.map((company) => company?.tenant_list?.map((tenant) => (
              <CompanyCard
                key={company.id}
                data={{ company, tenant, integration: tenant.integration }}
              />
          )))}
        <LoadMoreBtn actionToDispatch={companyPagination} store={companies} />
      </Box>
    </Box>
  )
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: { xs: 'auto', sm: 'unset' },
    padding: { xs: 'auto', sm: '0 15px' },
  },
  titleBox: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    width: '95%',
    gap: { xs: '5px', sm: '0px' },
    justifyContent: 'space-between',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    alignItems: { xs: 'flex-start', sm: 'normal' },
    margin: { xs: '0 0 10px 0', sm: 'unset' },
    svg: {
      fontSize: { xs: '20px', sm: 'unset' },
      marginTop: { xs: '10px', sm: 'unset' },
    },
  },
  welcomeHeader: {
    fontSize: { xs: '16px', sm: '24px' },
  },
  optionsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'normal', md: 'center' },
    marginTop: '2%',
  },
  sortAddBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: { xs: 'space-between', md: 'normal' },
    paddingTop: { xs: '10px', sm: 'unset' },
  },
  titleContainer: {
    paddingTop: { xs: '10px', sm: 'unset' },

  },
  body: {
    width: { xs: '95%', lg: '85%' },
  },
  searchBarContainer: {
    width: { xs: '100%', sm: '550px' },
    height: '40px',
  },
}

export default Index
